import { Location, useLocation as routerUseLocation } from 'react-router-dom';

import { Override } from '../types-utils';
import { LocationState } from '../useWizard/types';

export type TypedLocation = Override<Location, { state: LocationState }>;

export const useLocation = <S>() => routerUseLocation() as Override<Location, { state: S }>;
